import React from "react";
import './scenarioComponent.css'
import {ScenarioType} from "../domain/scenarioType";
import {StarsComponent} from "./starsComponent";
import {Scenario} from "../domain/bingoRenoAdvise";
import image1 from '../Bingo-visuel-scenario-1.svg';
import image2 from '../Bingo-visuel-scenario-2.svg';
import image3 from '../Bingo-visuel-scenario-3.svg';
import {Links} from "../domain/Links";

// Page proposition de scénarios
interface ScenarioProperties {
    index: number;
    scenario: Scenario
}

export function ScenarioComponent(props: ScenarioProperties) {

    function getWorks() {
        return <ul>
            {getScenario().works.map((w, index) => <li key={index}>{w}</li>)}
        </ul>;
    }

    function decriptionDisplayed() {
        switch (getScenario().name.toLowerCase()) {
            case 'ambitieux':
                return <> C'est le scénario le plus complet, à prioriser si vous pouvez le financer. Il vous permettra
                    de gagner en confort et en économies d'énergie.</>;
            case 'intermédiaire':
                return <>Vous ne pouvez pas vous lancer dans une rénovation complète en une fois ? Voici les travaux
                    préconisés, avec le meilleur compromis coût / économies d'énergie.</>;
            case 'budget restreint':
                return <>Vous ne pouvez pas vous lancer dans des travaux importants ? Voici les travaux les plus
                    pertinents pour votre maison, pour un budget réduit.</>;
            case 'optimisé':
                return <>Pour obtenir les meilleures performances possibles pour votre maison, voici le scénario à privilégier pour gagner encore en confort et en économies d'énergie.</>;
            case 'la touche finale':
                return <>Votre maison est déjà bien performante d'un point de vue énergétique. Mais vous pouvez encore l'améliorer! Voici les travaux préconisés pour optimiser votre facture.</>;
            default:
                throw new Error(`Unknown type : ${getScenario().name}`)
        }
    }

    function getScenario() {
        return props.scenario;
    }

    function getScenarioImage() {
        switch (props.scenario.type) {
            case ScenarioType.Ambitious:
                return image1;
            case ScenarioType.MidRange:
                return image2;
            case ScenarioType.SmallBudget:
                return image3;
        }
        return image1
    }

    function displayedName() {
        return getScenario().name.toUpperCase();
    }


    function getHeaderType() {
        return `Scenario-header-${props.index}`;
    }

    return (<div className="Scenario">
        <div className={`Scenario-header ${getHeaderType()}`}>
            <img className='Scenario-illustration' src={getScenarioImage()} alt="Scenario"/>
            <h3>Scénario {props.index}</h3>
            <div className='Scenario-type'>{displayedName()}</div>
            <span className='Scenario-price-container'>
                <span className='Scenario-price'>env. {getScenario().price.toLocaleString()}€*</span>
            </span>
            <div className='Scenario-description'>{decriptionDisplayed()}</div>
        </div>
        <div className='Scenario-my-works'>
            <h4>Travaux à réaliser pour ce scénario :</h4>
            {getWorks()}
        </div>
        <div className='Scenario-separator'></div>
        <div className='Scenario-badges'>
            <div className='Scenario-gains-container'>
                <h4>Gains pour vous : </h4>
            </div>
            <ul>
                <li className='Scenario-badge'>
                    <p className='Scenario-star-legend'>Baisse des factures</p>
                    <StarsComponent level={getScenario().lowerPayment}/>
                </li>
                <li className='Scenario-badge'>
                    <p className='Scenario-star-legend'>Amélioration du confort d'hiver</p>
                    <StarsComponent level={getScenario().improveWinterConfort}/>
                </li>
                <li className='Scenario-badge'>
                    <p className='Scenario-star-legend'>Amélioration du confort d'été</p>
                    <StarsComponent level={getScenario().improveSummerConfort}/>
                </li>
            </ul>

        </div>

    </div>)

}

